import { render, staticRenderFns } from "./imgTextContent.vue?vue&type=template&id=13d39ada&scoped=true"
import script from "./imgTextContent.vue?vue&type=script&lang=js"
export * from "./imgTextContent.vue?vue&type=script&lang=js"
import style0 from "./imgTextContent.vue?vue&type=style&index=0&id=13d39ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d39ada",
  null
  
)

export default component.exports